import { z } from "zod";

export const stateSchema = z.object({
  id: z.number(),
  name: z.string(),
  isEligible: z.boolean(),
  timezone: z.string(),
  isOther: z.boolean().optional(),
  providerGroup: z
    .object({ id: z.string(), name: z.string() })
    .nullish()
    .catch(null),
});
